<template>
  <SfModalPortal
    modal-id="manage-company-links-modal"
    data-walkthrough-id="manage-company-links-modal"
    size="l"
    :scrollable-content="true"
    :footer-padding="0"
    @close="onClose"
  >
    <template #title>
      <span v-if="currentCompanyName">
        {{
          I18n.t('company_links.manage_links', {
            company_name: currentCompanyName,
          })
        }}
      </span>
    </template>
    <template #body>
      <CompanyLinkCreator />
      <CompanyLinksOverview :modal-mode="true" />
    </template>
    <template #footer>
      <div
        class="
          tw-px-6
          tw-py-4
          tw-w-full
          tw-border-solid
          tw-border
          tw-border-b-0
          tw-border-l-0
          tw-border-r-0
          tw-border-sf-neutral-lighter-1
        "
      >
        <div class="sf-level sf-level-right">
          <SfButtonDs variant="secondary" @click="onCloseAndBack">{{
            I18n.t('common.form.done')
          }}</SfButtonDs>
        </div>
      </div>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import CompanyLinksOverview from './company-links-overview.vue'
import CompanyLinkCreator from './company-link-creator.vue'
import { useCompanyLinksStore } from '@app/application/company_links/store/use-company-links'
import { storeToRefs } from 'pinia'
import useI18n from '@app/shared/vue/composables/use-I18n'

defineOptions({
  name: 'ManageCompanyLinksModal',
})

const I18n = useI18n()

const companyLinksStore = useCompanyLinksStore()

const { currentCompanyName } = storeToRefs(companyLinksStore)

function onClose() {
  window.modalCitizen.closeModalPortal()
}

function onCloseAndBack() {
  onClose()
  window.modalCitizen.openModalPortal('external-company-selector-modal')
}
</script>
